export default class Footer {
    constructor() {
        // Footer
        this.itemsPosition();
    }

    itemsPosition() {
        const container = document.querySelector('.footer__menu.menu');
        const elts = document.querySelectorAll('.footer__menu.menu > .menu-item');
        if(container && elts.length > 0) {
            const gap = 10;
            elts.forEach((elt, index) => {
                elt.style.gridRowEnd = `span ${Math.round(elt.offsetHeight / 10) + 6}`;
            });

            container.style.gridTemplateColumns = 'repeat(3, minmax(250px,1fr))';
        }
    }
}